export default "__VITE_ASSET__9db21e40__"